import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Small } from 'foundations-components/transitional/components/Small';
import { H2 } from 'foundations-components/transitional/components/H2';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Link } from 'foundations-components/transitional/components/Link';
import { useMutation } from 'data-fetching-client';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { MIGRATION_REPORT_BY_ID_QUERY, PUBLISH_MIGRATION_MUTATION } from '../../knowledge-base/queries/KnowledgeBasesQuery';
import { selectCurrentKb, selectCurrentKbMigrationReport } from '../../knowledge-base/selectors/knowledgeBaseDetails';
import { refetchCache } from '../../migration-handler/singleton/migrationHandler';
import { getSettingUrl } from '../../routing/utils/externalUrls';
import UsageTracker from '../../utils/UsageTracker';
import { useAppSelector } from '../../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MigrationPublishModal = ({
  closeModal,
  screen
}) => {
  const {
    id: kbId,
    domain: kbDomain
  } = useAppSelector(selectCurrentKb);
  const kbMigration = useAppSelector(selectCurrentKbMigrationReport);
  const {
    slug: legacySlug
  } = kbMigration.legacyKnowledgeBase;
  const domainSlug = `${kbDomain}${legacySlug ? `/${legacySlug}` : ''}`;
  const [publishMigratedKB, {
    loading: isPublishing,
    error: publishError
  }] = useMutation(PUBLISH_MIGRATION_MUTATION, {
    variables: {
      migrationId: kbMigration.migration.id
    },
    refetchQueries: [{
      query: MIGRATION_REPORT_BY_ID_QUERY,
      variables: {
        migrationId: kbMigration.migration.id
      }
    }]
  });
  const handleCloseModal = () => {
    closeModal();
    UsageTracker.track('v3Migration', {
      screen,
      action: 'click-publish-later',
      isLegacyKnowledgeBase: false
    });
  };
  const publishKb = async () => {
    UsageTracker.track('v3Migration', {
      screen,
      action: 'click-publish-knowledgebase',
      isLegacyKnowledgeBase: false
    });
    await publishMigratedKB();
    await refetchCache();
    closeModal();
  };
  const handlePublishKb = () => {
    publishKb().catch(() => {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.v3MigrationPublish.toast.error"
        }),
        type: 'danger'
      });
    });
  };
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "migration-publish-modal",
    use: "success",
    width: 450,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.v3MigrationPublish.modal.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: handleCloseModal
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "knowledgeContentUI.v3MigrationPublish.modal.description"
      }), /*#__PURE__*/_jsx(Link, {
        external: true,
        href: "https://knowledge.hubspot.com/web-content/topics",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.v3MigrationPublish.modal.learnMoreArticleLinkText"
        })
      }), /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.v3MigrationPublish.modal.inputLabel"
        }),
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(TextInput, {
          name: "knowledge-base-url",
          defaultValue: domainSlug,
          readOnly: true
        })
      }), /*#__PURE__*/_jsx(Small, {
        weight: "medium",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "knowledgeContentUI.v3MigrationPublish.modal.disclaimer_jsx",
          elements: {
            UILink: Link
          },
          options: {
            href: getSettingUrl('knowledge', kbId)
          }
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      align: "center",
      children: [/*#__PURE__*/_jsx(LoadingButton, {
        failed: !!publishError,
        use: "primary",
        onClick: handlePublishKb,
        loading: isPublishing,
        "data-test-id": "publish-kb-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.v3MigrationPublish.modal.publishButton"
        })
      }), /*#__PURE__*/_jsx(Button, {
        disabled: isPublishing,
        use: "secondary",
        onClick: handleCloseModal,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.v3MigrationPublish.modal.cancelButton"
        })
      })]
    })]
  });
};
export default MigrationPublishModal;